import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Glasses",
        price: 270,
        disprice: 260,
        stock: 9,
        content: "Protect your eyes while enhancing your outdoor style with our durable and lightweight Glasses. Designed for adventurers, these glasses provide clear vision and UV protection during your journeys.",
        description: "Our Glasses are crafted for both functionality and fashion, making them the perfect companion for outdoor activities like hiking, camping, and traveling. Enjoy maximum comfort, durability, and eye protection under any condition.",
        category: ["Adventure Equipment", "Outdoor Apparel"],
        tags: ["Glasses", "Eyewear", "Outdoor Accessories"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Polycarbonate Lenses & Flexible Frame" },
            { id: 2, title: "Lens Type", content: "UV400 Protection Coated" },
            { id: 3, title: "Weight", content: "0.2 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Daniel Davis",
                date: "May 5, 2024",
                rating: 5,
                content: "Stylish and super comfortable glasses! Perfect for my hiking trips."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Emma Rodriguez",
                date: "May 6, 2024",
                rating: 5,
                content: "Great protection from the sun and very lightweight. Highly recommend!"
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Hiking Shoes",
        price: 290,
        disprice: 280,
        stock: 6,
        content: "Conquer every trail with confidence in our durable Hiking Shoes. Designed for maximum grip and comfort, these shoes are perfect for trekking, hiking, and outdoor adventures.",
        description: "Our Hiking Shoes feature a rugged sole for superior traction on rocky and uneven surfaces. The breathable design and cushioned support ensure your feet stay comfortable during long hikes and challenging terrains.",
        category: ["Hiking Essentials", "Adventure Equipment"],
        tags: ["Hiking Shoes", "Trekking Boots", "Outdoor Footwear"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Waterproof Leather & Mesh" },
            { id: 2, title: "Sole Type", content: "Non-slip Rubber Grip" },
            { id: 3, title: "Weight", content: "1.2 lbs (per pair)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Michael Brown",
                date: "May 10, 2024",
                rating: 5,
                content: "These hiking shoes are fantastic! Great grip and very comfortable even on long trails."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Camping Tent",
        price: 310,
        disprice: 300,
        stock: 3,
        content: "Stay protected and comfortable in the great outdoors with our premium Camping Tent. Designed for easy setup and durability, it’s perfect for weekend camping trips and extended outdoor adventures.",
        description: "Our Camping Tent features weather-resistant materials, a spacious interior, and a quick-pitch design for hassle-free setup. Ideal for all seasons, it provides reliable shelter against rain, wind, and sun while offering ventilation and comfort.",
        category: ["Camping Gear", "Adventure Equipment"],
        tags: ["Camping Tent", "Outdoor Shelter", "Adventure Gear"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Waterproof Polyester & Aluminum Poles" },
            { id: 2, title: "Dimensions", content: "8 x 6 x 4.5 feet" },
            { id: 3, title: "Weight", content: "6.5 lbs" }
        ],
        comments: []
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Torch",
        price: 330,
        disprice: 320,
        stock: 0,
        content: "Illuminate your path with our high-performance Torch, designed for adventurers who need reliable lighting in the darkest environments. Compact, powerful, and durable — it’s an essential for every outdoor kit.",
        description: "This Torch features a high-lumen LED beam with adjustable focus, ensuring bright and clear visibility on night treks, camping trips, or emergency situations. Built with rugged materials, it’s water-resistant and long-lasting.",
        category: ["Camping Gear", "Adventure Equipment"],
        tags: ["Torch", "Flashlight", "Outdoor Lighting"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Aluminum Alloy Body" },
            { id: 2, title: "Brightness", content: "1200 Lumens" },
            { id: 3, title: "Battery Life", content: "Up to 10 hours" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Olivia Smith",
                date: "May 12, 2024",
                rating: 5,
                content: "Super bright and very sturdy. I use it on all my night hikes!"
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "James Wilson",
                date: "May 13, 2024",
                rating: 5,
                content: "Best torch I’ve purchased—compact, reliable, and long battery life."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Skateboard",
        price: 350,
        disprice: 340,
        stock: 12,
        content: "Glide through the streets and skate parks with our premium Skateboard. Built for both beginners and pros, it offers perfect balance, control, and durability for all your freestyle tricks and smooth rides.",
        description: "Our Skateboard features a sturdy maple wood deck, high-grip wheels, and precision bearings for a stable and responsive ride. Whether you're cruising or performing tricks, this board is designed to handle all terrains with ease.",
        category: ["Adventure Equipment", "Hiking Essentials"],
        tags: ["Skateboard", "Street Sports", "Outdoor Activities"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "7-Ply Maple Wood Deck" },
            { id: 2, title: "Wheel Size", content: "52mm PU Wheels" },
            { id: 3, title: "Weight Capacity", content: "220 lbs" }
        ],
        comments: []
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Bagpack",
        price: 370,
        disprice: 360,
        stock: 7,
        content: "Carry your essentials in style and comfort with our versatile Bagpack. Designed for outdoor adventurers, this backpack offers ample storage, ergonomic design, and weather-resistant materials for all your trips.",
        description: "Our Bagpack features multiple compartments, padded shoulder straps, and a breathable back panel for maximum comfort on long hikes and travels. Its durable, water-resistant fabric ensures your gear stays safe and dry in any condition.",
        category: ["Hiking Essentials", "Camping Gear"],
        tags: ["Bagpack", "Hiking Backpack", "Travel Gear"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Water-Resistant Nylon" },
            { id: 2, title: "Capacity", content: "35 Liters" },
            { id: 3, title: "Weight", content: "1.5 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Sophia Lee",
                date: "May 15, 2024",
                rating: 5,
                content: "Very comfortable and fits all my hiking gear. Love the quality!"
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Ethan Clark",
                date: "May 16, 2024",
                rating: 5,
                content: "Excellent bagpack for trekking. Durable, spacious, and stylish."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Camera",
        price: 390,
        disprice: 380,
        stock: 4,
        content: "Capture every breathtaking moment of your adventure with our high-performance Camera. Designed for travelers and outdoor enthusiasts, this compact yet powerful camera delivers stunning image quality in every shot.",
        description: "Our Camera features a high-resolution lens, optical zoom, and image stabilization for sharp and vibrant photos even in challenging environments. Its rugged, weather-resistant build makes it ideal for outdoor photography, ensuring you never miss a moment.",
        category: ["Photography Tools", "Adventure Equipment"],
        tags: ["Camera", "Travel Photography", "Adventure Gear"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "20.1 Megapixels" },
            { id: 2, title: "Zoom", content: "10x Optical Zoom" },
            { id: 3, title: "Battery Life", content: "Up to 400 shots per charge" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Lucas Miller",
                date: "May 18, 2024",
                rating: 4,
                content: "Great compact camera for travel. Quality is impressive for the price."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Binoculars",
        price: 410,
        disprice: 400,
        stock: 0,
        content: "Enhance your outdoor explorations with our high-clarity Binoculars. Designed for nature lovers and adventurers, these binoculars offer crystal-clear magnification and are perfect for birdwatching, wildlife observation, and scenic viewing.",
        description: "Our Binoculars feature multi-coated lenses for superior image quality, a durable waterproof body, and ergonomic grip for comfortable handling during extended use. Experience sharp visuals even in low-light conditions.",
        category: ["Photography Tools", "Adventure Equipment"],
        tags: ["Binoculars", "Wildlife Watching", "Outdoor Optics"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Magnification", content: "10x42 HD Lenses" },
            { id: 2, title: "Field of View", content: "330ft/1000yds" },
            { id: 3, title: "Weight", content: "1.3 lbs" }
        ],
        comments: []
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Hat",
        price: 150,
        disprice: 140,
        stock: 10,
        content: "Shield yourself from the sun with our lightweight and breathable Hat. Designed for outdoor adventures, this hat offers comfort, style, and essential UV protection for all-day wear.",
        description: "Our Hat features moisture-wicking fabric, an adjustable strap for a perfect fit, and a wide brim to protect you from harsh sunlight. Ideal for hiking, camping, or casual outdoor activities, it combines practicality with a sleek design.",
        category: ["Outdoor Apparel", "Hiking Essentials"],
        tags: ["Hat", "Sun Protection", "Outdoor Apparel"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "100% Breathable Cotton" },
            { id: 2, title: "Brim Width", content: "3 inches" },
            { id: 3, title: "Weight", content: "0.4 lbs" }
        ],
        comments: []
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Eyewear",
        price: 275,
        disprice: 265,
        stock: 20,
        content: "Protect your eyes with our stylish and functional Eyewear, designed for outdoor enthusiasts who value both safety and fashion. Perfect for hikes, camps, and everyday adventures under the sun.",
        description: "Our Eyewear features polarized lenses for glare reduction, UV400 protection, and a lightweight, flexible frame for all-day comfort. Whether you’re trekking through mountains or enjoying a sunny day at the beach, this eyewear ensures maximum clarity and protection.",
        category: ["Outdoor Apparel", "Adventure Equipment"],
        tags: ["Eyewear", "Sunglasses", "Outdoor Accessories"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Lens Type", content: "Polarized UV400 Protection" },
            { id: 2, title: "Frame Material", content: "Flexible Polycarbonate" },
            { id: 3, title: "Weight", content: "0.18 lbs" }
        ],
        comments: []
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Trekking Boots",
        price: 295,
        disprice: 285,
        stock: 18,
        content: "Engineered for challenging terrains, our Trekking Boots offer unmatched grip, ankle support, and comfort for serious hikers and outdoor explorers.",
        description: "These Trekking Boots are crafted with waterproof leather, a reinforced toe cap, and shock-absorbing soles to ensure durability and safety on every trail. Ideal for mountain hikes, rough landscapes, and long-distance treks.",
        category: ["Hiking Essentials", "Adventure Equipment"],
        tags: ["Trekking Boots", "Hiking Shoes", "Outdoor Footwear"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Waterproof Leather & Breathable Mesh" },
            { id: 2, title: "Sole Type", content: "Vibram Anti-Slip Outsole" },
            { id: 3, title: "Weight", content: "1.8 lbs (per pair)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Noah Anderson",
                date: "May 20, 2024",
                rating: 5,
                content: "Superb grip and comfort! I’ve used them on rocky trails and they perform excellently."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Outdoor Tent",
        price: 315,
        disprice: 305,
        stock: 10,
        content: "Experience the great outdoors in comfort with our spacious and weather-resistant Outdoor Tent. Perfect for camping trips, festivals, and outdoor adventures.",
        description: "Our Outdoor Tent is designed with a quick-setup mechanism, durable waterproof fabric, and excellent ventilation to ensure a hassle-free and comfortable stay. Its lightweight frame and compact packing size make it easy to carry for any adventure.",
        category: ["Camping Gear", "Adventure Equipment"],
        tags: ["Outdoor Tent", "Camping Shelter", "Adventure Gear"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Durable Ripstop Polyester" },
            { id: 2, title: "Capacity", content: "Fits 3-4 People" },
            { id: 3, title: "Weight", content: "7 lbs" }
        ],
        comments: []
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Flashlight",
        price: 335,
        disprice: 325,
        stock: 22,
        content: "Light up your adventures with our ultra-bright Flashlight, designed for outdoor enthusiasts who need reliable illumination in all conditions.",
        description: "Our Flashlight features a powerful LED beam with multiple light modes, including high, low, and strobe. Built with durable, water-resistant materials, it’s perfect for camping, hiking, and emergency use. Compact, lightweight, and designed to withstand rugged environments.",
        category: ["Camping Gear", "Adventure Equipment"],
        tags: ["Flashlight", "LED Torch", "Outdoor Lighting"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Aerospace-Grade Aluminum" },
            { id: 2, title: "Brightness", content: "1500 Lumens" },
            { id: 3, title: "Battery Life", content: "Up to 12 hours" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Amelia Harris",
                date: "May 22, 2024",
                rating: 5,
                content: "Bright, durable, and compact. I always keep it in my hiking gear."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Skateboard Deck",
        price: 355,
        disprice: 345,
        stock: 15,
        content: "Build your perfect ride with our premium Skateboard Deck, crafted for durability and precision control, ideal for skaters who love freestyle tricks and park sessions.",
        description: "Our Skateboard Deck is made from high-quality 7-ply maple wood, ensuring maximum strength and flexibility. The concave design offers superior grip and stability, perfect for riders of all skill levels aiming to upgrade their skating experience.",
        category: ["Adventure Equipment", "Hiking Essentials"],
        tags: ["Skateboard Deck", "Freestyle Skate", "Outdoor Sports"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "7-Ply Canadian Maple Wood" },
            { id: 2, title: "Dimensions", content: "32 x 8 inches" },
            { id: 3, title: "Weight Capacity", content: "250 lbs" }
        ],
        comments: []
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Travel Backpack",
        price: 375,
        disprice: 365,
        stock: 28,
        content: "Carry all your essentials with ease using our spacious and ergonomic Travel Backpack. Designed for adventurers, it’s perfect for long treks, city tours, and weekend getaways.",
        description: "Our Travel Backpack features multiple compartments for organized storage, padded shoulder straps for comfort, and durable water-resistant fabric to protect your belongings. Its sleek design and large capacity make it a reliable companion for any trip.",
        category: ["Hiking Essentials", "Camping Gear"],
        tags: ["Travel Backpack", "Hiking Gear", "Adventure Bag"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Water-Resistant Polyester" },
            { id: 2, title: "Capacity", content: "45 Liters" },
            { id: 3, title: "Weight", content: "2.2 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Liam Parker",
                date: "May 25, 2024",
                rating: 5,
                content: "Very spacious and comfortable. Perfect for my hiking trips!"
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Mia Thompson",
                date: "May 26, 2024",
                rating: 5,
                content: "Great design and very durable. Highly recommended for travelers."
            }
        ]
    }

];

export default products;